const JobIcon = () => {
  return (
    <svg
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.0009 9.34148C16.2655 10.924 13.1603 11.755 10.0001 11.75C6.8405 11.755 3.73576 10.9243 1.00073 9.34228M8.87512 8.75H11.1251M13.7501 4.25V2.75C13.7501 2.35218 13.5921 1.97064 13.3108 1.68934C13.0295 1.40804 12.6479 1.25 12.2501 1.25H7.75012C7.35229 1.25 6.97076 1.40804 6.68946 1.68934C6.40815 1.97064 6.25012 2.35218 6.25012 2.75V4.25M1.75085 4.25H18.2509C18.6651 4.25 19.0009 4.58579 19.0009 5V17C19.0009 17.4142 18.6651 17.75 18.2509 17.75H1.75085C1.33664 17.75 1.00085 17.4142 1.00085 17V5C1.00085 4.58579 1.33664 4.25 1.75085 4.25Z"
        stroke="#B721FF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default JobIcon;
